import React, { useEffect } from 'react';
import { isCdkEnvironment } from '../utils/constants';

// components
import { DocumentHead } from '../components/DocumentHead';
import { ChooseRecordingOptions } from '../components/record/ChooseRecordingOptions';
import { RecordSettingsProvider } from '../context/record/provider';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';

export const VideoReplyPage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    const language = localStorage.getItem('language');
    if (language) {
      i18n.changeLanguage(language);
    }
  }, []);
  const title = isCdkEnvironment
    ? `CDK - ${t('video reply')}`
    : `Covideo - ${t('video reply')}`;
  return (
    <>
      <DocumentHead title={title} />
      <RecordSettingsProvider>
        <ChooseRecordingOptions />
      </RecordSettingsProvider>
    </>
  );
};
